import React, { useContext, useEffect, useMemo, useState } from "react";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import themeContext from "../../../../../context/theme/ThemeContext";

const AddTabVersion = (props) => {
    const {showVersionModalForReport,setShowVersionModalForReport} = useContext(studylistContext);
    const {getThemeColor,themeName} = useContext(themeContext);
    return (<>
    <div className="table-report">
        <ul id="horizontal-list" style={{minWidth:'unset'}} >
          {props?.data?.map((report, index) => {
            return (
              <li
                onClick={() => {
                    props.setActiveTabIndex(index);
                }}
                id={report.reportTemplateId}
                key={index}
                className={
                    index == props.activeTabIndex ? `${themeName}-active-li li-tab` : " li-tab"
                  }
                style={{background:  getThemeColor('report-not-active-tab'),color: getThemeColor("primary-color")}}
              >
                <span>{report.reportTemplateTitle}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </>)
};

export default AddTabVersion;